import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { SectionHeader } from "./GameDebugInfoUI";
import { BorderPrimary, FontColorHighlight, FontColorModerate, GUIHeadlineSuffix, GUISelectableText, GUISubBox, GUIHeadline, GUITextDebug, GUITextNormalDebug } from "../GameUIElements";
import { toHumanReadableId } from "../../../../../shared/helper/actionTreeHelper";
import { gameStore } from "../../../../stores/GameStore";
import { useThrottle } from "@react-hook/throttle";
import { autorun } from "mobx";
import { getActionShortDescriptionForActionEditor } from "../../../../helper/actionEditorHelpers";
import { actionNodeIcon } from "../../../action/actionNodeData";
const ScrollContainer = styled(GUISubBox).withConfig({
  displayName: "ActiveTriggerDebugUI__ScrollContainer",
  componentId: "sc-146b1wk-0"
})(["display:flex;flex-direction:column;height:100%;overflow-y:scroll;width:100%;"]);
const TriggerContainer = styled.div.withConfig({
  displayName: "ActiveTriggerDebugUI__TriggerContainer",
  componentId: "sc-146b1wk-1"
})(["display:flex;flex-direction:column;margin:2px;padding:2px;", ""], BorderPrimary);
const Trigger = observer(({
  actionId
}) => {
  const {
    t
  } = useTranslation();
  const action = gameStore.gameEngine.getCachedActionNode(actionId);
  if (!action) return null;
  return /*#__PURE__*/React.createElement(TriggerContainer, {
    key: actionId
  }, /*#__PURE__*/React.createElement(GUITextNormalDebug, {
    color: FontColorHighlight
  }, actionNodeIcon(action), t(action.title())), /*#__PURE__*/React.createElement(GUITextNormalDebug, {
    color: FontColorModerate
  }, getActionShortDescriptionForActionEditor(action, t)), /*#__PURE__*/React.createElement(GUITextDebug, null, "id:", /*#__PURE__*/React.createElement(GUISelectableText, null, toHumanReadableId(actionId))));
});
export const ActiveTriggerDebugUI = () => {
  const {
    t
  } = useTranslation();

  const getActiveTriggers = () => gameStore.gameEngine ? Array.from(gameStore.gameEngine.gameState.activeTriggerActions.values()) : [];

  const [activeTriggers, setActiveTriggers] = useThrottle(getActiveTriggers(), 2);
  useEffect(() => {
    return autorun(() => {
      if (gameStore.debugLogAndTriggerAutoRefresh) {
        setActiveTriggers(getActiveTriggers());
      }
    });
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SectionHeader, null, /*#__PURE__*/React.createElement(GUIHeadline, null, t("game.debug_headline_history_active_trigger"), " "), /*#__PURE__*/React.createElement(GUIHeadlineSuffix, null, "(" + activeTriggers.length + ")")), /*#__PURE__*/React.createElement(ScrollContainer, null, activeTriggers.map(actionId => /*#__PURE__*/React.createElement(Trigger, {
    key: actionId,
    actionId: actionId
  }))));
};